// extracted by mini-css-extract-plugin
module.exports = {"cut":"wires_cut__T85c2"};